<template>
  <v-chip label class="red lighten-2 white--text mb-2">{{ title }}</v-chip>
</template>

<script>
export default {
  name: 'EnvironmentBadge',
  props: ['title'],
};
</script>

<style>
</style>
